import React, { Component } from 'react'
import axios from 'axios';
import {BrowserRouter, NavLink, Route ,Switch} from 'react-router-dom';
import {App} from './App';
import { withRouter } from "react-router";
import {Table} from 'react-bootstrap';
import {Button,ButtonToolbar} from 'react-bootstrap';
import {AddTechnologyModal} from './AddTechnologyModal';
import {EditTechnologyModal} from './EditTechnologyModal';
import queryString from 'query-string';
import { BulkUpload } from './BulkUpload';
class AdminTechnology extends Component {
  constructor (props){
    super(props);
    this.state = {
        TechnologyList:[],
        addModalShow:false,
        editModalShow:false,
        bulkuploadmodalshow:false,
        username:"",
        techlist:[],
        towerlist:[]
    }               
}


componentDidMount() {
    this.getTechnologyList();
    this.handleQueryString();
    this.gettech();
    this.gettechIO();
    document.title ="KTPlanConfigurator";
}
gettech() {
 
  fetch("https://as-mobilization.accenture.com/KTPlanConfig/api/Index/TechnologyList/AO").then(response => response.json())
  .then(res=> {            
    this.setState ( { techlist: res } )
      })
      .catch(err => {
        console.log(err);
    }) 

}
gettechIO() {
 
  fetch("https://as-mobilization.accenture.com/KTPlanConfig/api/Index/TechnologyList/IO").then(response => response.json())
  .then(res=> {            
    this.setState ( { towerlist: res } )
      })
      .catch(err => {
        console.log(err);
    }) 

}

filterClickTest = () => {
  fetch("https://as-mobilization.accenture.com/KTPlanConfig/api/AdminTechnology/Get").then(response => response.json())
    .then(res=> {            
      this.setState ( { TechnologyList: res} )
        })
        .catch(err => {
          console.log(err);
      }) 
      console.log(this.state.TechnologyList);
      this.state.editModalShow= false ;
      this.state.addModalShow = false;
}
close = () => {
  
  this.state.editModalShow= false ;
}

handleQueryString = () => {
  let queries = queryString.parse(window.location.search)
  if(queries.username !=undefined)
  {
    this.state.username = queries.username;
  }
}
TopicClick() {

  this.props.history.push({

    pathname: '/AdminTopics',
    search:"?username="+this.state.username,
  })  
}
adminClick(){

  this.props.history.push({

    pathname: '/',
    
    state: {  username:this.state.username},
    search:"?username="+this.state.username,
})
}
TasksClick() {

  this.props.history.push({

    pathname: '/AdminTasks',
    search:"?username="+this.state.username,
  })  
}

TasksHeaderClick() {

  this.props.history.push({

    pathname: '/AdminTaskHeader',
    search:"?username="+this.state.username,
  })  
}
TopicTechClick() {

  this.props.history.push({

    pathname: '/AdminTopicTechMapping',
    search:"?username="+this.state.username,
  })  
}

TopicTechdefaultClick() {

  this.props.history.push({

    pathname: '/AdmindefaultTopicTechMapping',
    search:"?username="+this.state.username,
  })  
}

getTechnologyList() {
    fetch("https://as-mobilization.accenture.com/KTPlanConfig/api/AdminTechnology/Get").then(response => response.json())
    .then(res=> {            
      this.setState ( { TechnologyList: res} )
        })
        .catch(err => {
          console.log(err);
      }) 
      console.log(this.state.TechnologyList);
  }

  GetAMSFile() {
    fetch("https://as-mobilization.accenture.com/KTPlanConfig/api/ExcelBulkUpload/GetFile/AO")
    .then(response => {
    
      response.blob().then(blob => {
        let url = window.URL.createObjectURL(blob);
        let a = document.createElement('a');
        a.href = url;
       
        a.download ="KTPlan_AMS_Template"+".xlsx";
        
        a.click();
        this.setState({show:true}) 
      });
    });
  }

  GetIMSFile() {
    fetch("https://as-mobilization.accenture.com/KTPlanConfig/api/ExcelBulkUpload/GetFile/IO")
    .then(response => {
    
      response.blob().then(blob => {
        let url = window.URL.createObjectURL(blob);
        let a = document.createElement('a');
        a.href = url;
       
        a.download ="KTPlan_IMS_Template"+".xlsx";
        
        a.click();
        this.setState({show:true}) 
      });
    });
  }

render() {
  const {TechnologyId,Technology,ServiceGroup,filterchangetest,Close,username,DomainId,Default,defaultrequired,techlist,towerlist} = this.state;
    let addModalClose=()=>this.setState({addModalShow:false});
    let editModalClose=()=>this.setState({editModalShow:false});
    let bulkuploadclose=()=>this.setState({bulkuploadmodalshow:false});
    return (
        <div class="bg-background" style={{background:'#F2F2F2'}}>
        <div class="row">
            <div class="container-fluid">
            <div class="header-content" style={{marginLeft:40}}>
              <img src="images/Capture.png" style={{paddingBottom:5}} alt="Accenture Technology" class="img-icon" />
              <span class="new-KT-navbar" style={{marginLeft:5}}>KT Plan Configurator</span>
              <button type='button' style={{marginLeft:850,marginTop:5}}  className='btn-new btn-confirm' onClick={() => this.adminClick()}>KT Plan</button>
        </div>
        <div class="row" style={{marginBottom:5}}>
        <div class='col-md-6'></div>
              <div class='col-md-2'>
              <button type='button' style={{marginTop:5,width:120,fontSize:12}}  className='btn-new btn-confirm' onClick={() => this.GetAMSFile()}>AMS Template</button>
              </div>
              <div class='col-md-2'>
              <button type='button' style={{marginTop:5,width:120,fontSize:12}}  className='btn-new btn-confirm' onClick={() => this.GetIMSFile()}>IMS Template</button>
              </div>
              <div class='col-md-2'>
              <button type='button' onClick={()=>this.setState({bulkuploadmodalshow:true})} className='btn-new btn-confirm' style={{marginTop:5,width:120,fontSize:12}} >Bulk Upload</button>
              </div>   
          </div>
              <div class="demographic-form margin-top15 border-main-div new-KT" style={{height:500,overflow:'auto'}} >
              <div class="ul-financials margin-bottom15">
              <a class="active" style={{marginRight:50,color:'black',fontWeight:'bold',borderBottom:2,borderBottomColor:'#7500c0',borderBottom:'solid',paddingBottom:5}} href="#">Technology</a>
              <a  Text="Header" style={{marginRight:50,color:'black',fontWeight:'bold'}}  ID="lnkTasksHeaders" onClick={() => this.TasksHeaderClick()} >Tasks Header Maintenance</a>
              <a  Text="Tasks" style={{marginRight:50,color:'black',fontWeight:'bold'}} onClick={() => this.TasksClick()} ID="lnkTasks" >Tasks Maintenance</a>                             
                <a Text="Topic" style={{marginRight:50,color:'black',fontWeight:'bold'}} onClick={() => this.TopicClick()} ID="lnkTopic" >Topic Maintenance</a>
                <a  Text="Topic Technology" style={{marginRight:50,color:'black',fontWeight:'bold'}} onClick={() => this.TopicTechClick()} >Topic-Technology Mapping</a>
                <a  Text="Topic Technology default" style={{marginRight:50,color:'black',fontWeight:'bold'}} onClick={() => this.TopicTechdefaultClick()} >Default Technology</a>

            </div>
             
              <div class="col-md-12 " >
                      <button type='button'  className='btn-new' onClick={()=>this.setState({addModalShow:true})} style={{marginBottom:5}} >New Technology</button>
                   
                     
                    </div>
                 <Table className='mt-4' striped bordered hover size='sm'>
                   <thead style={{background:'#e6dcff'}}>
                       <tr>
                      
                       <th>Technology/Tower</th>
                       <th>Service Group</th>
                       <th></th>
                       </tr>
                   </thead>
                   <tbody>
                       {
                       this.state.TechnologyList.map(obj=>
                       <tr key={obj.technologyid}>
                          
                            <td>{obj.technology}</td>
                            <td>{obj.Servicegroup=='IO'?'IMS':'AMS'}</td>
                            <td>
                            
                              <ButtonToolbar>
                              <img src="images/edit-new.png" onClick={()=>this.setState({editModalShow:true,
                                Technology:obj.technology,TechnologyId:obj.technologyid,ServiceGroup:obj.Servicegroup,DomainId:obj.DomainId,Default:obj.Default,defaultrequired:obj.defaultrequired})} alt=""/>
                               
                               
                               
                              </ButtonToolbar>
                            </td>
                       </tr>
                       )}
                   </tbody>
                 </Table>
                  </div> 
                  </div>
                  </div>
                  <ButtonToolbar>
                    <AddTechnologyModal show={this.state.addModalShow}
                     filterchangetest = {this.filterClickTest}
                     username = {this.state.username}
                     onHide={addModalClose}/>
                    <EditTechnologyModal  show={this.state.editModalShow}
                               onHide={editModalClose}
                               TechnologyId={TechnologyId}
                               Technology={Technology}
                               ServiceGroup={ServiceGroup}
                               filterchangetest = {this.filterClickTest}
                               Close={this.close}
                               DomainId = {DomainId}
                               Default = {Default}
                               username = {this.state.username}
                               defaultrequired = {defaultrequired}
                               techlist = {ServiceGroup == 'AO'?this.state.techlist:this.state.towerlist}
                               ></EditTechnologyModal>
                               <BulkUpload show={this.state.bulkuploadmodalshow}
                               onHide={bulkuploadclose}/>
                  </ButtonToolbar>
                  </div>
    )
}
}
export default withRouter(AdminTechnology);
